import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Inter — the DrStack design names Inter but the original static site never loaded it. Self-hosted
// via @fontsource so the rebuild renders the intended type on every machine (weights per
// DESIGN-TOKENS.md: 400 body, 500 nav/labels, 600 buttons, 700 headings/wordmark, 800 display).
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "./design-tokens.css";
import "./styles.css";
import { App } from "./App";
import { initObservability } from "./observability";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

void initObservability(); // Sentry (PHI-scrubbed, PII off) — no-op without a DSN

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
